<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">{{$t('newJob')}}</strong>
                <strong v-else>{{$t('editJob')}}</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">
                <strong v-if="status_form!=0">{{edit_name}}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm"  class="mr-1 ml-1" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" class="mr-1 ml-1"  @click="emptyList()"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>


              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="4">
                <CInput
                    :label="$t('jobName')"
                    horizontal
                    v-model="name"
                    autocomplete="name"
                />
              </CCol>

<!--              <CCol col="4">-->
<!--                <CRow form class="form-group">-->
<!--                  <CCol tag="label" sm="3" class="col-form-label">-->
<!--                    واحد اداری-->
<!--                  </CCol>-->
<!--                  <CCol sm="9">-->
<!--                    <treeselect-->
<!--                        :appendToBody="true"-->
<!--                        v-model="selected_chart"-->

<!--                        :options="data_accounting"-->
<!--                        :normalizer="normalizer_filter_item"-->

<!--                    />-->
<!--                  </CCol>-->

<!--                </CRow>-->
<!--              </CCol>-->
            </CRow>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6">
        <CCard>
          <CCardHeader>
            <strong>{{$t('jobsList')}}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items"
                :fields="fields"
                @row-clicked="table_row_clicked"
                :items-per-page="10"
                hover
                sorter
                striped
                border
                column-filter
                pagination
            >
              <template #row="{item,index}">

                <td>
                  <p >{{ index + 1 }}</p>
                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>


              <template #parentId="{item}">

                <td>
                  <div>
                    {{ get_parent(item) }}
                  </div>
                </td>

              </template>


              <template #operation="{item}">
                <td>

<!--                    <CIcon @click.native="edit_item(item)" class="text-primary" name="cil-pencil"/>-->

                    <CIcon @click.native="delete_item_dialog(item)" class="text-danger" name="cilTrash"/>

                </td>
              </template>


            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


var items = [];


export default {
  name: 'JobPositions',
  components: {
    Treeselect,

  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      name: '',
      edit_name: '',
      file: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      data_accounting:[],
      selected_chart:null,
      table_clicks_timer:null,
      table_clicks:0,
      data_with_children:[],
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false,filter:false, _style: 'width:3%'},
        {key: 'title', label: this.$t('tables.name'), _style: 'width:20%'},
        // {key: 'parentId', label: "واحد اداری", _style: 'width:20%'},
        {key: 'operation', label: "",filter:false, _style: 'width:3%;'},
      ],
      collapseDuration: 0,
      status_form: 0,
      normalizer_filter_item(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,

        }
      },
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
this.get_departments();
    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    get_parent(item){
      return this.data_with_children.filter(item2 => item2.id == item.parentId)[0].title
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.description != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      if (this.description == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      }
      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.title;
      this.edit_name = item.title;
      this.selected_chart = item.parentId;
      this.status_form = item.id;

    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }
    },
    get_departments() {
      var self = this;

      const formData = new FormData();

      formData.append('Id', 0);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.data_accounting = []


          self.data_with_children = response.data.data;
          response.data.data.forEach((val) => {
            if (val.parentId == 0) {

              var obj = {
                "name": val.title,

                parentId: val.parentId,
                id: val.id,
                recType: val.recType,

                // "selected":true,
                children: self.get_childrens(val.id, response.data.data),
                // mate: self.get_mates(val.id, response.data.data)
              }

              self.data_accounting.push(obj);
            }

          });
          if (self.selected_node == 0) {
            self.selected_node = self.data_accounting.children[0];
            // this.selected_node = node
          }
          // self.get_mate_accounts()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            name: val2.title,
            id: val2.id,
            children: this.get_childrens(val2.id, list),
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,

            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);

          // val2.inserted = true;

        }
        // if (parent_id == val2.parentId &&val2.recType == 1) {
        //   var obj2 = {
        //     name: val2.title,
        //     id: val2.id,
        //     children: this.get_childrens(val2.id, list),
        //     // mate: this.get_mates(val2.id, list),
        //     recType: val2.recType,
        //
        //     class:["my_mate"],
        //     parentId: val2.parentId,
        //     image_url: '/img/avatars/custom2.png',
        //
        //   }
        //   array.push(obj2);

        // val2.inserted = true;

        // }
      });
      if (array.length) {
        return array;

      } else {
        return null;

      }

    },

    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('RecType', 1);


      axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data = content_data.data.filter(x=>x.title!=null);
          content_data.data.sort((a, b) => a.title.localeCompare(b.title, undefined, {numeric: true, sensitivity: 'base'}));

          self.items.push(...content_data.data)

          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items = self.items.filter(item => item.recType == 1);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: "/dashboard/products/list-brand/" + item.id})
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      // this.addGroupModal = false;
if(this.name==null || this.name==""){
  return false;
}

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "MainDeparteman/Add";

      } else {
        url = "MainDeparteman/Update";
        formData.append('id', this.status_form)

      }
      formData.append('ParentId',0);


      formData.append('recType', 1);
      formData.append('title', this.name);
      // formData.append('branchId', this.selected_branch);

      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();


      })

          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "MainDeparteman/Delete";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
